import { LysaLink } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./AccessibilityLink.scss";

const ACCESSIBILITY_URL = "https://www.lysa.se/tillganglighet";

export const AccessibilityLink = () => {
  return (
    <div className="accessibility-link">
      <LysaLink
        href={ACCESSIBILITY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage id="sweden.story.accessibilityLink" />
      </LysaLink>
    </div>
  );
};
